module.exports = __webpack_public_path__ + "img/Z82_06.72ee78e7.jpg";